/*
 * Personal Digital Spaces LLC ("COMPANY") CONFIDENTIAL
 * Unpublished Copyright (c) 2025 Personal Digital Spaces LLC, All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of COMPANY. The intellectual and technical concepts contained
 * herein are proprietary to COMPANY and may be covered by U.S. and Foreign Patents, patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from COMPANY.  Access to the source code contained herein is hereby forbidden to anyone except current COMPANY employees, managers, contractors or partners who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of  COMPANY.   ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */
import { ASSET_LICENSING_BATCH_LABEL } from '@/configs/strings/items-labels'
import { formatEmptyValue } from '@/utils/assets'
import { getBatchNames, getDefaultCardDetailsData } from '@/utils/cards.utils'
import { createId } from '@/utils/general'
import { getFileTypeIconUrl, normalizeValueArrayToString, setPreviewUrl } from '@/utils/items'

const getCommonValues = (item) => {
  const title = item.title
  const assetId = item.assetId
  const creators = formatEmptyValue(
    normalizeValueArrayToString(item.creators?.map(c => c.name))
  )
  const publishers = formatEmptyValue(
    normalizeValueArrayToString(item.publishers?.map(p => p.name))
  )
  const fileType = normalizeValueArrayToString(item.fileType)
  const assetsLicensesBatch = getBatchNames({
    batchKey: 'assetsLicensesBatch',
    batchNameKey: 'name',
    containerValue: item.licensedAssets
  })

  return {
    assetId,
    assetsLicensesBatch,
    creators,
    fileType,
    id: item.id,
    publishers,
    title
  }
}

export const setItemCustomProps = (item) => {
  const {
    assetId,
    assetsLicensesBatch,
    creators,
    fileType,
    id,
    publishers,
    title
  } = getCommonValues(item)
  const itemDetails = [
    ...getDefaultCardDetailsData({
      assetIdValue: assetId,
      fileTypeValue: fileType,
      publisherValue: publishers
    }),
    {
      label: ASSET_LICENSING_BATCH_LABEL,
      value: assetsLicensesBatch
    }
  ]

  return {
    creators,
    itemDetails,
    fileType,
    id,
    title,
    imageUrl: setPreviewUrl(item?.coverUrl, fileType)
  }
}

export const getItemPropByTable = (item) => {
  const {
    assetId,
    assetsLicensesBatch,
    creators,
    fileType,
    id,
    publishers,
    title
  } = getCommonValues(item)

  return {
    assetId,
    assetsLicensesBatch,
    creators,
    fileType,
    iconUrl: getFileTypeIconUrl(fileType),
    id,
    key: createId(),
    publishers,
    title
  }
}

export const tableColumns = [
  {
    title: '',
    id: 'checkbox'
  },
  {
    title: '',
    id: 'icon'
  },
  {
    title: 'Asset Id',
    id: 'assetId'
  },
  {
    title: 'Title',
    id: 'title'
  },
  {
    title: 'Creators',
    id: 'creators'
  },
  {
    title: 'Publishers',
    id: 'publishers'
  },
  {
    title: 'File Type',
    id: 'fileType'
  },
  {
    title: ASSET_LICENSING_BATCH_LABEL,
    id: 'assetsLicensesBatch'
  }
]
